import { format } from 'timeago.js';

export default class TimeAgo {
	constructor() {
		document.addEventListener('bless', ({ detail }) => {
			this.container = detail.next.container;
			this.init();
		});
	}

	init() {
		const elements = this.container.querySelectorAll('[data-timestamp]');

		elements.forEach(element => {
			const ts = parseInt(element.dataset.timestamp, 10);
			const pubDate = new Date(ts * 1000);
			const now = new Date();
			const diff = now.getTime() - pubDate.getTime();
			const diffInDays = diff / (1000 * 3600 * 24);

			if (diffInDays < 8) {
				element.innerHTML = format(pubDate);
				element.classList.add('has-date-hydrated');
			}
		});
	}
}
